import script from "./BviButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BviButton.vue?vue&type=script&setup=true&lang=js"

import "./BviButton.vue?vue&type=style&index=0&id=09576e08&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09576e08"]])

export default __exports__